<script>
export default {
    name: "ModifyAdmissionForm",

    data() {

        return {
            admission: {
                date: window.moment().format(`YYYY-MM-DD`),
                username: this.$root.username,

            }
        }
    },

    props: {
        showModal: Boolean,
        patient: Object,
        employees: Array,
    },

    methods: {

        saveData() {

            this.$root.loading = true;
            this.$http.post(`Morgue/ModifyAdmission?PatientID=${this.patient.patienT_ID}&TrxDate=${this.admission.date}&AdmittedBy=${this.admission.admittedBy}&UserName=${this.admission.username}`).then(response => {
                this.$emit('refresh');
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({text: response.data, type: `success`});
            }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 sm:w-full">
      <template v-slot:title>
        <h5 class="font-bold text-base">Modify Admission</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="w-full p-tiny bg-blue-800 text-white text-sm rounded-t">
                <h5 class="font-bold">Patient Details</h5>
            </div>
            <div class="w-full flex flex-wrap text-sm border-r-2 border-l-2 border-b-2 border-blue-800 rounded-b">
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <h5 class="font-bold">Name: <span class="text-blue-800">{{ patient.patient }}</span></h5>
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <h5 class="font-bold">MRN: <span class="text-blue-800">{{ patient.patienT_ID }}</span></h5>
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <h5 class="font-bold">ID Number: <span class="text-blue-800">{{ patient.nationalid }}</span></h5>
                </div>
            </div>
            <div class="w-full flex flex-wrap mt-2">
                <div class="md:w-1/2 sm:w-full p-tiny">
                    <label for="grid-date-admitted" class="label-control">Date Admitted:</label>
                    <input type="date" v-model="admission.date" id="grid-date-admitted" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/2 sm:w-full p-tiny">
                    <label for="grid-admitted-by" class="label-control">Admitted By:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select v-model.trim="admission.admittedBy" id="grid-admitted-by" class="input-control input-sm text-xs">
                                <option value="">Select employee</option>
                                <option v-for="(emp, idx) in employees" :key="idx" :value="emp.employeeID">{{ emp.names }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-6" @click="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>
